import type { TodoDescriptor } from '../../schema/TodoDescriptor';
import { assertNever } from 'owa-assert';
import {
    isTodoFolderDescriptor,
    isTodoMyDayDescriptor,
    isTodoDueDateDescriptor,
} from '../typeGuards';
import { buildTodoFolderDescriptorFilter } from './buildTodoFolderDescriptorFilter';
import type { TodoFilterFunction } from '../../schema/TodoFilterFunction';
import { buildTodoMyDayDescriptorFilter } from './buildTodoMyDayDescriptorFilter';
import { buildTodoDueDateDescriptorFilter } from './buildTodoDueDateDescriptorFilter';

export function buildTodoDescriptorFilter(todoDescriptor: TodoDescriptor): TodoFilterFunction {
    if (isTodoFolderDescriptor(todoDescriptor)) {
        return buildTodoFolderDescriptorFilter(todoDescriptor);
    } else if (isTodoMyDayDescriptor(todoDescriptor)) {
        return buildTodoMyDayDescriptorFilter(todoDescriptor);
    } else if (isTodoDueDateDescriptor(todoDescriptor)) {
        return buildTodoDueDateDescriptorFilter(todoDescriptor);
    }
    return assertNever(todoDescriptor);
}
